export default __webpack_public_path__ + "static/media/OFFSITEAM-dark.e229f6f2.svg";